<template>
  <div>
    <h1>Test email</h1>
    <v-select
      label="Choose entity"
      :items="conveyancers"
      v-model="conveyancerid"
      item-value="id"
      item-text="name"
      outline
      @change="valueChanged"
    />
    <!-- <v-text-field label="File id" v-model="fileid" outline /> -->
    <v-btn-toggle v-model="viewMode" mandatory>
      <v-btn flat small value="html">HTML</v-btn>
      <v-btn flat small value="text">Text</v-btn>
    </v-btn-toggle>
    <v-card>
      <v-card-text>
        <iframe
          ref="iframeHtml"
          :srcdoc="emailMessage.htmlBody"
          style="border: 0; width: 100%;"
          :height="height"
          v-if="viewMode == 'html'"
        />
        <div style="white-space: pre-wrap;" v-if="viewMode == 'text'">{{emailMessage.textBody}}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "TestEmail",
  metaInfo() {
    return {
      title: "Test email",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      emailMessage: {},
      conveyancers: null,
      conveyancerid: null,
      fileid: null,
      height: 100,
      viewMode: "html"
    };
  },
  methods: {
    fetchTestEmail() {
      nbmlaw
        .get(`/cors/admin/message/testEmail`, {
          params: { entityid: this.conveyancerid, fileid: this.fileid }
        })
        .then(response => {
          // console.log(response.data);
          this.emailMessage = response.data;
        })
        .catch(() => {});
    },
    fetchConveyancers() {
      nbmlaw
        .get(`/cors/admin/directory/types/2/entities`)
        .then(response => {
          // console.log(response.data);
          this.conveyancers = response.data;
        })
        .catch(() => {});
    },
    resizeIframeHeight() {
      setTimeout(() => {
        this.height = this.$refs.iframeHtml
          ? this.$refs.iframeHtml.contentDocument.body.scrollHeight + "px"
          : undefined;
      }, 200);
    },
    valueChanged() {
      this.fetchTestEmail();
    }
  },
  watch: {
    emailMessage: {
      immediate: true,
      handler() {
        this.resizeIframeHeight();
      },
      deep: true
    }
  },
  created() {
    this.fetchConveyancers();
    this.fetchTestEmail();
  }
};
</script>